import _ from 'underscore';
import { toIANATimeZone } from '@bingads-webui-universal/time-zone-converter';

export function reformatDate(i18n, dateStr, timeZone, skeleton = 'yMdhms') {
  if (_.isString(dateStr)) {
    const date = new Date(dateStr);
    const formatter = i18n.dateFormatter({
      skeleton,
      timeZone: toIANATimeZone(timeZone) || 'UTC',
    });

    return formatter(date).replace(',', '');
  }

  return dateStr;
}

export const util = {
  reformatDate,
};
